import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { selectIsLoadingSomeData } from '../common/store/slice'
import classes from './index.module.scss'
import {
  selectLoadingTotalResult,
  selectSelectedIndicatorCount,
  selectTotalResult,
  validateCriteria,
} from './store/slice'

export const NextButton = ({ navigateToExportScreen }) => {
  const dispatch = useDispatch()

  const selectedIndicatorCount = useSelector(selectSelectedIndicatorCount)
  const totalResult = useSelector(selectTotalResult)
  const isLoadingTotalResult = useSelector(selectLoadingTotalResult)
  const isLoadingSomeData = useSelector(selectIsLoadingSomeData)

  const isDisabled =
    !selectedIndicatorCount ||
    !totalResult ||
    isLoadingSomeData ||
    isLoadingTotalResult

  const handleClick = () => {
    dispatch(
      validateCriteria({
        callback: (isValid) => {
          if (isValid) navigateToExportScreen()
        },
      }),
    )
  }

  return (
    <Element className={classes.nextBtn}>
      <Element
        elementName="button"
        disabled={isDisabled}
        style={{
          color: isDisabled ? '#9C9C9C' : '#FFFFFF',
          backgroundColor: isDisabled ? '#D5D5D5' : '#2C73E8',
        }}
        onClick={handleClick}
      >
        <Translate value="screening.NEXT" />
      </Element>
    </Element>
  )
}
